import React from 'react'
import parse from 'html-react-parser'
import * as styles from './styles.module.scss'
import translate from '../../../../../../helpers/Translate'
import question from '../../../../../../images/icons/question-icon.svg'
import { RatingTooltip } from '../../../../../rating-tooltip/RatingTooltip'
import { Link } from 'gatsby'
import ShopPrices from '../../../../../shop-prices'

export const LoopItemTopRating = ({ 
    author,
    title, 
    ratingPro, 
    price, 
    quality, 
    design, 
    easeofuse, 
    dynamicLabel1,
    dynamicLabel2,
    opretShopBar,
    singleReviewPostId,
    productScrapedPrices,
    allShops,
    productPrices,
    isRoundup = false,
}) => {
    

    let shopPrices = productScrapedPrices ? JSON.parse( productScrapedPrices ) : null

    if ( isRoundup ) {
        const productPricesParsed = productPrices ? JSON.parse( productPrices ) : []
        const product_id = singleReviewPostId?.databaseId

        let shops_and_prices = productPricesParsed.filter( item => item.product_id === product_id )

        if ( shops_and_prices['0'] ) {
            shops_and_prices = shops_and_prices['0']['0']?.replace(/\\\//g, "/")
            if ( shops_and_prices ) {
                shopPrices = JSON.parse( shops_and_prices )
            }
        }

    }
    
    const ratingsCount = [ 1, 2, 3, 4, 5 ]

    let priceValue

    const priceReduced = price / 100 * 5

    priceValue = parseFloat( priceReduced.toFixed(1) )


    /**
     * User rating calculations
     */

    let userRating = 0

    let ratings = []

    opretShopBar?.forEach(item => {

        item.review !== null && ratings.push({ review : item.review, numberReviews : item.numberReviews })
        
    })

    let ratingValue = 0

    let totalRevievs = 0 // the total revievs number from all shops

    ratings.forEach( item => {

        totalRevievs = totalRevievs + item.numberReviews // 

        ratingValue = ratingValue + ( item.numberReviews * item.review )

    })

    if( ratingValue === 0 ) {

        userRating = parseFloat( 0 ) 

    } else {

        userRating = parseFloat( ratingValue / totalRevievs ).toFixed( 1 )

    }

    /** === End User rating calculations === */

    /**
     * Bedbible rating
     */
    let biblieRating

    if ( ratingPro !== null && ratingPro !== undefined ) {

        biblieRating = parseFloat( ratingPro.toFixed(1) )

    } else {

        biblieRating = 3.5 // Default rating value
        
    }

    /** === End Bedbible rating === */

    let overAllRating = ratingPro?.toFixed( 1 )
    if ( userRating && userRating !== 0 ) {
        overAllRating = (( parseFloat( ratingPro ) + parseFloat( userRating ) ) / 2 ).toFixed( 1 )
    } 

    let authorName = singleReviewPostId?.author ? singleReviewPostId.author.node.name : null

    let authorUrl = singleReviewPostId?.author ? singleReviewPostId.author.node.uri : null

    if ( null === authorName ) {
        authorName = author.name
        authorUrl = author.uri
    }

    return(
        <div className={styles.rating}>
            <div className={styles.main__rating}>
                <div className={styles.count} style={{ marginRight : '9px' }}>
                    <span>{overAllRating}</span>
                    <span>/5</span>
                </div>
                <div className={styles.main__rating__title}>
                    <span>{translate('Overall Rating')}</span>
                    <img src={question} alt={translate('Bedbible Rating')} />
                    <div className={styles.tooltip}>
                        <div className={styles.tooltip__table}>
                            <div className={styles.top}>
                                <p>{translate('Overall Rating')}</p>
                                <p>{overAllRating}<span>/5</span></p>
                            </div>

                            <div className={styles.experts}>
                                <p>{translate('Bedbible Rating:')}</p>
                                <p>{ratingPro}/5</p>
                            </div>
                            <div className={styles.comment} style={{ marginBottom : '10px', paddingBottom: '10px', borderBottom: '1px solid #E9E9E9' }}>
                                <p>{translate('Reviewed by:')}&nbsp;</p>
                                <Link to={authorUrl}>{authorName}</Link>
                            </div>
                            <div className={styles.experts}>
                                <p>{translate('User Ratings:')}</p>
                                <p>{userRating}/5</p>
                            </div>
                            <div className={styles.comment}>
                                <p>{parse(translate(`Based on <span>${totalRevievs}&nbsp;</span>user reviews`, totalRevievs))}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.overall__rating}>
                <div className={styles.overall__rating__item}>
                    <div className={styles.count}>
                        <span>{design}</span>
                        <span>/100</span>
                    </div>

                    <div className={styles.info}>
                        <span>{translate('Design')}</span>
                        <img src={question} alt='Beginner' />
                        <div className={styles.tooltip}>
                            <RatingTooltip
                                rating={design}
                                product={title}
                                valueType={100}
                                type={'design'}
                                zIndex={96}
                                dynamicLabel1={dynamicLabel1}
                                dynamicLabel2={dynamicLabel2}
                                isRoundup={true}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.overall__rating__item}>
                    <div className={styles.count}>
                        <span>{easeofuse}</span>
                        <span>/100</span>
                    </div>

                    <div className={styles.info}>
                        <span>{translate('Ease of Use')}</span>
                        <img src={question} alt='Ease of Use' />
                        <div className={styles.tooltip}>
                            <RatingTooltip
                                rating={easeofuse}
                                product={title}
                                valueType={100}
                                type={'easeOfUse'}
                                zIndex={96}
                                dynamicLabel1={dynamicLabel1}
                                dynamicLabel2={dynamicLabel2}
                                isRoundup={true}
                            />
                        </div>
                    </div>
                </div>

                <div className={styles.overall__rating__item}>
                    <div className={styles.count}>
                        <span>{quality}</span>
                        <span>/100</span>
                    </div>

                    <div className={styles.info}>
                        <span>{translate('Quality')}</span>
                        <img src={question} alt='Quality' />
                        <div className={styles.tooltip}>
                            <RatingTooltip
                                rating={quality}
                                product={title}
                                valueType={100}
                                type={'quality'}
                                zIndex={96}
                                dynamicLabel1={dynamicLabel1}
                                dynamicLabel2={dynamicLabel2}
                                isRoundup={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <ShopPrices shopPrices={shopPrices} allShops={allShops} opretShopBar={opretShopBar}/>

        </div>
    )
}